import React from 'react';
import { KeyLists, Search, UserDetails } from '../containers';
import { useAllInOneContext, useActiveListContext } from '../../context';
import { Core } from '..';
import { Desktop, Mobile } from '../../media_queries';

export default function Header({ setShowTasks = null }) {
  const { loadPage, progress, setProgress } = useAllInOneContext();
  const { themeColor } = useActiveListContext();

  return (
    <>
      <Core.ForceAlert
        progress={progress}
        setProgress={setProgress}
        color={themeColor}
        showBox={loadPage}
      >
        Getting Ready...
      </Core.ForceAlert>

      <Desktop>
        <KeyLists />
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Search />
          <UserDetails />
        </div>
      </Desktop>

      <Mobile>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Search isMobile={true} />
          <UserDetails />
        </div>
        <KeyLists setShowTasks={setShowTasks} />
      </Mobile>
    </>
  );
}
